import { activity } from "./es/activity";
import { auth } from "./es/auth";
import { certificates } from "./es/certificates";
import { common } from "./es/common";
import { errors } from "./es/errors";
import { home } from "./es/home";
import { my } from "./es/my";
import { nav } from "./es/nav";
import { organization } from "./es/organization";
import { people } from "./es/people";
import { platform } from "./es/platform";
import { policies } from "./es/policies";
import { shared } from "./es/shared";

/**
 * Textos en español (idioma por defecto y de referencia). Un espacio de nombres
 * por pantalla o zona, cada uno en su fichero de `./es/`; `en` tiene que tener
 * exactamente las mismas claves (lo comprueban el tipo `Translation` y un test).
 *
 * Interpolación `{{x}}`; plurales con sufijos `_one` / `_other` (i18next).
 * Fechas y números: `useFormat()` de `@/i18n/format` (Intl), no en el texto.
 */
export const es = {
  shared,
  common,
  nav,
  auth,
  home,
  certificates,
  policies,
  people,
  activity,
  organization,
  my,
  platform,
  errors,
};
